
export default {
  draft: {
    label: 'Rascunho',
    description: 'Não está pronto para publicar.'
  },
  pending_launch: {
    label: 'Aguardando Lançamento',
    description: 'Aguardando revisão antes de publicar, visível apenas para administradores e editores.'
  },
  active: {
    label: 'Ativo',
    description: 'Visível apenas para administradores e editores.'
  },
  maintenance: {
    label: 'Em manutenção',
    description: 'Visível apenas para administradores e editores.'
  },
  inactive: {
    label: 'Inativo',
    description: 'Site inativo.'
  } ,
  suspended: {
    label: 'Suspenso',
    description: 'Visível apenas para administradores e editores.'  
  },
  archived: {
    label: 'Arquivado',   
    description: 'Visível apenas para administradores e editores.'
  },
  
  options:[
    { value: 'draft', label: 'Rascunho' },
    { value: 'pending_launch', label: 'Aguardando Lançamento' },
    { value: 'active', label: 'Ativo' },
    { value: 'maintenance', label: 'Em manutenção' },
    { value: 'inactive', label: 'Inativo' },
    { value: 'suspended', label: 'Suspenso' },
    { value: 'archived', label: 'Arquivado' }
  ]
}